import { lazy } from 'react';

export const BusinessAreaWareHouseList = lazy(() => import('./business_area_ware_house/BusinessAreaWareHouseList'));
export const AddBusinessAreaWareHouse = lazy(() => import('./business_area_ware_house/AddBusinessAreaWareHouse'));
export const UpdateBusinessAreaWareHouse = lazy(() => import('./business_area_ware_house/UpdateBusinessAreaWareHouse'));
export const CityList = lazy(() => import('./city/CityList'));
export const AddCity = lazy(() => import('./city/AddCity'));
export const UpdateCity = lazy(() => import('./city/UpdateCity'));
export const CompanyList = lazy(() => import('./company/CompanyList'));
export const AddCompany = lazy(() => import('./company/AddCompany'));
export const UpdateCompany = lazy(() => import('./company/UpdateCompany'));
export const CompanyBusinessAreaList = lazy(() => import('./company_business_area/CompanyBusinessAreaList'));
export const AddCompanyBusinessArea = lazy(() => import('./company_business_area/AddCompanyBusinessArea'));
export const UpdateCompanyBusinessArea = lazy(() => import('./company_business_area/UpdateCompanyBusinessArea'));
export const CostCenterList = lazy(() => import('./cost_center/CostCenterList'));
export const AddCostCenter = lazy(() => import('./cost_center/AddCostCenter'));
export const UpdateCostCenter = lazy(() => import('./cost_center/UpdateCostCenter'));
export const CountryList = lazy(() => import('./country/CountryList'));
export const AddCountry = lazy(() => import('./country/AddCountry'));
export const UpdateCountry = lazy(() => import('./country/UpdateCountry'));
export const CurrencyList = lazy(() => import('./currency/CurrencyList'));
export const AddCurrency = lazy(() => import('./currency/AddCurrency'));
export const UpdateCurrency = lazy(() => import('./currency/UpdateCurrency'));
export const MainMenuList = lazy(() => import('./main_menu/MainMenuList'));
export const AddMainMenu = lazy(() => import('./main_menu/AddMainMenu'));
export const UpdateMainMenu = lazy(() => import('./main_menu/UpdateMainMenu'));
export const PermissionMenuList = lazy(() => import('./permission_menu/PermissionMenuList'));
export const AddPermissionMenu = lazy(() => import('./permission_menu/AddPermissionMenu'));
export const UpdatePermissionMenu = lazy(() => import('./permission_menu/UpdatePermissionMenu'));
export const RoleList = lazy(() => import('./role/RoleList'));
export const AddRole = lazy(() => import('./role/AddRole'));
export const UpdateRole = lazy(() => import('./role/UpdateRole'));
export const AssignRolePermission = lazy(() => import('./role_permission/AssignRolePermission'));
export const StateList = lazy(() => import('./state/StateList'));
export const AddState = lazy(() => import('./state/AddState'));
export const UpdateState = lazy(() => import('./state/UpdateState'));
export const SubMenuList = lazy(() => import('./sub_menu/SubMenuList'));
export const AddSubMenu = lazy(() => import('./sub_menu/AddSubMenu'));
export const UpdateSubMenu = lazy(() => import('./sub_menu/UpdateSubMenu'));
export const TaxList = lazy(() => import('./tax/TaxList'));
export const AddTax = lazy(() => import('./tax/AddTax'));
export const UpdateTax = lazy(() => import('./tax/UpdateTax'));
export const TaxTypeList = lazy(() => import('./tax_type/TaxTypeList'));
export const AddTaxType = lazy(() => import('./tax_type/AddTaxType'));
export const UpdateTaxType = lazy(() => import('./tax_type/UpdateTaxType'));
export const UserRoleList = lazy(() => import('./user_role/UserRoleList'));
export const AddUserRole = lazy(() => import('./user_role/AddUserRole'));
export const UpdateUserRole = lazy(() => import('./user_role/UpdateUserRole'));